enum EventSessionStatus {
  Available = 'Available',
  NotAvailable = 'NotAvailable',

  Selected = 'Selected',
}
export default EventSessionStatus;
